import { makeApiActionCreatorV3 } from '@actions/utils';

import * as api from '../api/firm';

const namespace = 'FIRM';

export const FETCH_FIRMS_START = `${namespace}/FETCH_FIRMS_START`;
export const FETCH_FIRMS_SUCCESS = `${namespace}/FETCH_FIRMS_SUCCESS`;
export const FETCH_FIRMS_ERROR = `${namespace}/FETCH_FIRMS_ERROR`;

export const fetchFirms = makeApiActionCreatorV3(
  api.fetchFirms,
  FETCH_FIRMS_START,
  FETCH_FIRMS_SUCCESS,
  FETCH_FIRMS_ERROR,
);

export const FETCH_FIRM_START = `${namespace}/FETCH_FIRM_START`;
export const FETCH_FIRM_SUCCESS = `${namespace}/FETCH_FIRM_SUCCESS`;
export const FETCH_FIRM_ERROR = `${namespace}/FETCH_FIRM_ERROR`;

export const fetchFirm = makeApiActionCreatorV3(
  api.fetchFirm,
  FETCH_FIRM_START,
  FETCH_FIRM_SUCCESS,
  FETCH_FIRM_ERROR,
);

export const FETCH_FIRM_FILES_START = `${namespace}/FETCH_FIRM_FILES_START`;
export const FETCH_FIRM_FILES_SUCCESS = `${namespace}/FETCH_FIRM_FILES_SUCCESS`;
export const FETCH_FIRM_FILES_ERROR = `${namespace}/FETCH_FIRM_FILES_ERROR`;

export const fetchFirmFiles = makeApiActionCreatorV3(
  api.fetchFirmFiles,
  FETCH_FIRM_FILES_START,
  FETCH_FIRM_FILES_SUCCESS,
  FETCH_FIRM_FILES_ERROR,
);

export const INSERT_FIRM_START = `${namespace}/INSERT_FIRM_START`;
export const INSERT_FIRM_SUCCESS = `${namespace}/INSERT_FIRM_SUCCESS`;
export const INSERT_FIRM_ERROR = `${namespace}/INSERT_FIRM_ERROR`;

export const insertFirm = makeApiActionCreatorV3(
  api.insertFirm,
  INSERT_FIRM_START,
  INSERT_FIRM_SUCCESS,
  INSERT_FIRM_ERROR,
);

export const INSERT_FIRM_FILE_START = `${namespace}/INSERT_FIRM_FILE_START`;
export const INSERT_FIRM_FILE_SUCCESS = `${namespace}/INSERT_FIRM_FILE_SUCCESS`;
export const INSERT_FIRM_FILE_ERROR = `${namespace}/INSERT_FIRM_FILE_ERROR`;

export const insertFirmFile = makeApiActionCreatorV3(
  api.insertFirmFile,
  INSERT_FIRM_FILE_START,
  INSERT_FIRM_FILE_SUCCESS,
  INSERT_FIRM_FILE_ERROR,
);

export const UPDATE_FIRM_START = `${namespace}/UPDATE_FIRM_START`;
export const UPDATE_FIRM_SUCCESS = `${namespace}/UPDATE_FIRM_SUCCESS`;
export const UPDATE_FIRM_ERROR = `${namespace}/UPDATE_FIRM_ERROR`;

export const updateFirm = makeApiActionCreatorV3(
  api.updateFirm,
  UPDATE_FIRM_START,
  UPDATE_FIRM_SUCCESS,
  UPDATE_FIRM_ERROR,
);

export const DELETE_FIRM_START = `${namespace}/DELETE_FIRM_START`;
export const DELETE_FIRM_SUCCESS = `${namespace}/DELETE_FIRM_SUCCESS`;
export const DELETE_FIRM_ERROR = `${namespace}/DELETE_FIRM_ERROR`;

export const deleteFirm = makeApiActionCreatorV3(
  api.deleteFirm,
  DELETE_FIRM_START,
  DELETE_FIRM_SUCCESS,
  DELETE_FIRM_ERROR,
);

export const DELETE_FIRM_FILE_START = `${namespace}/DELETE_FIRM_FILE_START`;
export const DELETE_FIRM_FILE_SUCCESS = `${namespace}/DELETE_FIRM_FILE_SUCCESS`;
export const DELETE_FIRM_FILE_ERROR = `${namespace}/DELETE_FIRM_FILE_ERROR`;

export const deleteFirmFile = makeApiActionCreatorV3(
  api.deleteFirmFile,
  DELETE_FIRM_FILE_START,
  DELETE_FIRM_FILE_SUCCESS,
  DELETE_FIRM_FILE_ERROR,
);

export const DOWNLOAD_FIRM_FILE_START = `${namespace}/DOWNLOAD_FIRM_FILE_START`;
export const DOWNLOAD_FIRM_FILE_SUCCESS = `${namespace}/DOWNLOAD_FIRM_FILE_SUCCESS`;
export const DOWNLOAD_FIRM_FILE_ERROR = `${namespace}/DOWNLOAD_FIRM_FILE_ERROR`;

export const downloadFirmFile = makeApiActionCreatorV3(
  api.downloadFirmFile,
  DOWNLOAD_FIRM_FILE_START,
  DOWNLOAD_FIRM_FILE_SUCCESS,
  DOWNLOAD_FIRM_FILE_ERROR,
);

export const SET_CURRENT_FIRM = `${namespace}/SET_CURRENT_FIRM`;

export const setCurrentFirm = firm => ({
  type: SET_CURRENT_FIRM,
  payload: firm,
});

export const SEARCH_START = `${namespace}/SEARCH_START`;
export const SEARCH_SUCCESS = `${namespace}/SEARCH_SUCCESS`;
export const SEARCH_ERROR = `${namespace}/SEARCH_ERROR`;

export const search = makeApiActionCreatorV3(
  api.search,
  SEARCH_START,
  SEARCH_SUCCESS,
  SEARCH_ERROR,
);

export const FETCH_FIRM_PARTIES_START = `${namespace}/FETCH_FIRM_PARTIES_START`;
export const FETCH_FIRM_PARTIES_SUCCESS = `${namespace}/FETCH_FIRM_PARTIES_SUCCESS`;
export const FETCH_FIRM_PARTIES_ERROR = `${namespace}/FETCH_FIRM_PARTIES_ERROR`;

export const fetchFirmParties = makeApiActionCreatorV3(
  api.fetchFirmParties,
  FETCH_FIRM_PARTIES_START,
  FETCH_FIRM_PARTIES_SUCCESS,
  FETCH_FIRM_PARTIES_ERROR,
);

export const CHANGE_PAGE = `${namespace}/CHANGE_PAGE`;

export const changePage = page => ({
  type: CHANGE_PAGE,
  payload: page,
});

export const CHANGE_ROWS_PER_PAGE = `${namespace}/CHANGE_ROWS_PER_PAGE`;

export const changeRowsPerPage = rowsPerPage => ({
  type: CHANGE_ROWS_PER_PAGE,
  payload: rowsPerPage,
});

export const CHANGE_SORT_MODEL = `${namespace}/CHANGE_SORT_MODEL`;

export const changeSortModel = model => ({
  type: CHANGE_SORT_MODEL,
  payload: model,
});

export const CHANGE_FILTER_MODEL = `${namespace}/CHANGE_FILTER_MODEL`;

export const changeFilterModel = model => ({
  type: CHANGE_FILTER_MODEL,
  payload: model,
});
